import React from 'react';
import { useTranslation } from '@lt/localization';
import HotelRating from 'src/components/HotelRating';
import type { SearchParamsType } from 'src/routes/Hotel/store/selectors/searchParams';
import { pluralizeReviews } from 'src/utils/pluralizeUtils';
import { Link } from '@lt/components';
import type { ReviewsProps } from '@lt/api/dist/methods/hotelReviews/types';
import { Sorting } from 'src/components/Sorting';
import { SORT_TYPES_REVIEWS } from 'src/components/Sorting/constants';
import type { SortingPosition } from 'src/components/Sorting/types';
import type { RelinkHotelsType } from '../../HotelRelink';
import HotelRelink from '../../HotelRelink';
import Paper from '../../Paper';
import ReviewList from './ReviewList';

import styles from '../reviews.module.css';

interface ReviewsDesktopProps {
  isRatingExists: boolean;
  isWhitelabel: boolean;
  hasReviewsSection: boolean;
  className?: string;
  linkedHotels: RelinkHotelsType;
  totalReviews: number;
  searchParams: SearchParamsType;
  isShowMoreReviews: boolean;
  hotelReviewsLink: string;
  isFetching: boolean;
  isLoadingNew: boolean;
  items: ReviewsProps[];
  showMore: () => void;
  sorting: SortingPosition;
  onChangeSorting: ({ order, field }: SortingPosition) => void;
}

const ReviewsDesktop = ({
  isRatingExists,
  linkedHotels,
  searchParams,
  isWhitelabel,
  hasReviewsSection,
  totalReviews,
  className,
  isShowMoreReviews,
  hotelReviewsLink,
  isFetching,
  items,
  showMore,
  isLoadingNew,
  onChangeSorting,
  sorting,
}: ReviewsDesktopProps) => {
  const showLinkedHotels = !isWhitelabel && linkedHotels.length > 0;
  const { t } = useTranslation();
  return (
    <div className={className}>
      {hasReviewsSection && (
        <div className={styles.linkTitleBlock}>
          {isWhitelabel ? (
            <div
              className={styles.linkTitle}
            >{`${totalReviews} ${pluralizeReviews(totalReviews)}`}</div>
          ) : (
            <Link
              href={hotelReviewsLink}
              className={styles.linkTitle}
            >{`${totalReviews} ${pluralizeReviews(totalReviews)}`}</Link>
          )}
        </div>
      )}
      <div className={styles.ltHotelReviewsRow}>
        <div className={styles.reviewsContainer}>
          <Sorting
            className={styles.sorting}
            isMapView={false}
            isMobile={false}
            field={sorting.field}
            awaitFiltration={false}
            changeSorting={onChangeSorting}
            sortTypes={SORT_TYPES_REVIEWS}
            order={sorting.order}
          />
          <ReviewList
            items={items}
            isShowMoreReviews={isShowMoreReviews}
            showMore={showMore}
            isLoadingNew={isLoadingNew}
            hasReviewsSection={hasReviewsSection}
            isFetching={isFetching}
          />
        </div>
        {(isRatingExists || showLinkedHotels) && (
          <div className={styles.rating}>
            <HotelRating />
            {showLinkedHotels && (
              <Paper padding={10}>
                <div className={styles.heading}>{t('hotel.similarHotels')}</div>
                <HotelRelink
                  hotels={linkedHotels}
                  searchParams={searchParams}
                />
              </Paper>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReviewsDesktop;
